import styled from "styled-components";

export const Container = styled.div<{ isTableHeaderVisible: boolean }>`
  .ant-table-wrapper {
    .ant-table-cell {
      font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
      font-size: 17px;
      font-weight: 700;
      line-height: 47px;
      letter-spacing: -0.05em;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }

    .ant-table-header {
      display: ${({ isTableHeaderVisible }) =>
        isTableHeaderVisible ? "table-header-group" : "none"};
      .ant-table-cell {
        font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
        font-size: 18px;
        &::before {
          content: none !important;
        }
      }
      .ant-table-thead > tr > th {
        border: none;
        background: #f3f3f3;
        padding: 27px 8px;
        text-align: center;
        @media screen and (max-width: 768px) {
          padding: 27px 5px;
        }
      }
    }
    .ant-table-body {
      cursor: pointer;
      .ant-table-tbody > tr > td {
        padding: 27px 10px;
        text-align: center;
      }

      .ant-table-tbody > tr > .text-number {
        color: #8e8e8e;
        font-weight: 800;
      }
    }
  }
  /** pagination */
  .ant-pagination {
    margin-top: 42px;
    align-items: center;
    gap: 0px;

    .ant-pagination-item-ellipsis {
      top: 30%;
    }

    .ant-pagination-options {
      display: none;
    }
  }
`;
